import React from 'react'
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import UserDividerItem from './Divider'
import { useCognitoProvider } from '../../providers/CognitoContext';
import { actions } from '../../actions/cognito';
import UserDisabledItem from './Disabled';
import { useHistory } from 'react-router-dom';
import { useMenuProvider } from '../../providers/MenuContext';
import { redirectAfterImpersonationActions } from '../../utils/functions';
import { useAssignmentsProvider } from '../../providers/AssignmentsContext';

/**
 * Implementación de las opciones de impersonación de usuarios operador.
 * @param {Object} props - Propiedades del componente.
 * @param {Function} props.handleClose - Función que permite cerrar el menú de usuario.
 * @returns {React.Component}
 */
export default function UserImpersonations({ handleClose }) {

    const { state } = useAssignmentsProvider()
    const { dispatch: cognitoDispatch } = useCognitoProvider();
    const history = useHistory();
    const { setCurrentRoute } = useMenuProvider();

    /**
     * Funcion para impersonar un usuario operador.
     */
    const handleImpersonate = index => event => {
        cognitoDispatch({ 
            type: actions.IMPERSONATE, 
            payload: { codOperator: state.assignments[index].codOperador, pkOperador: state.assignments[index].pkPerson } 
        });
        redirectAfterImpersonationActions(history, setCurrentRoute);
        if (handleClose) handleClose();
    }

    return (
        state.assignments && state.assignments.length > 0
            ? <>
                <UserDividerItem />
                <UserDisabledItem>
                    <Typography variant="inherit" noWrap><strong>Autorizaciones</strong></Typography>
                </UserDisabledItem>
                <UserDividerItem />
                {state.assignments.map((assignment, index) => {
                    return <>
                        <MenuItem onClick={handleImpersonate(index)}>
                            <Typography variant="inherit" noWrap>{assignment.description}</Typography>
                        </MenuItem>
                    </>
                })}
            </>
            : <></>
    )
}
